import { render } from "./SelectLabelsForPickType.vue?vue&type=template&id=68855bc0"
import script from "./SelectLabelsForPickType.vue?vue&type=script&lang=js"
export * from "./SelectLabelsForPickType.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__